import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../../../types/types';
import { ICommentHOCProps } from './types';
import { Comment } from '../../components/Comment/Comment';
import { ICardCommentEvents, ICardCommentFields } from '../../components/Comment/types';
import { onRemove } from './events/onRemove';
import { getAuthUser } from '../../../../../../../store/model/authUser/selectors/getAuthUser';
import { onReply } from './events/onReply';
import { onGetLink } from './events/onGetLink';
import { getEditCommentId } from '../../../../../../../store/router/selectors/getEditCommentId';
import { onEdit } from './events/onEdit';
import { getCommentReply } from './selectors/getCommentReply';
import { onAttachmentReply } from './events/onAttachmentReply';
import { getCommentReplyAttachment } from './selectors/getCommentReplyAttachment';
import { getDriveDoc } from '../../../../../../../store/model/driveDocs/selectors/getDriveDoc';
import { onAttachmentClick } from './events/onAttachmentClick';
import { getCommentReplyText } from './selectors/getCommentReplyText';
import { isEqual } from 'underscore';
import { getCardIsLoading } from '../../../../../../../store/requestsState/selectors/getCardIsLoading';
import { getBoardIdByCardId } from '../../../../../../../store/model/selectors/getBoardIdByCardId';
import { getSectionType } from '../../../../../aside_panel/cardDetails/selectors/getSectionType';
import { ESettingsSectionType } from '../../../SettingsSection/types';
import { getCommentDriveDocsByIds } from '../../selectors/getCommentDriveDocsByIds';
import { getCommentById } from '../../selectors/getCommentById';
import { onLike } from '../events/onLike';
import { getUserTimeFormat12 } from '../../../../../../../store/model/authUser/selectors/getUserTimeFormat12';

// const analyze = new Analyze('CommentHOC');
// 10 раз открыл-закрыл карту
// noReselect               average: 0.041 ms, calls: 268, total: 10.900 ms
// createDeepEqualSelector  average: 0.031 ms, calls: 280, total: 8.800 ms
// cache                    average: 0.034 ms, calls: 280, total: 9.400 ms // чуть дольше, но тут много свойств объектов

const mapStateToProps = () => {
    interface ICaheProps extends ICardCommentFields{};
    let cache: ICaheProps = null;
    const getCache = (
        value: ICaheProps
    ): ICaheProps => {
        if (isEqual(value, cache)) {
            return cache;
        }
        cache = value;
        return value;
    };

    return (
        state: IApplicationState,
        { comment, boardId, isNewDivider, isChatView, isSameUserNextComment, isSameUserPrevComment }: ICommentHOCProps
    ): ICardCommentFields => {
        // analyze.start();
        const { cardId, id, driveDocIds, author, meta } = comment;
        const { hash } = getAuthUser(state);
        const replyCommentId = getCommentReply(state, cardId, id);
        const replyAttachmentId = getCommentReplyAttachment(state, cardId, id);
        const commentDriveDocs = getCommentDriveDocsByIds(state, id, driveDocIds);
        const sectionType = getSectionType(state, boardId, cardId, null, null, 'allowComment');
        const isReadonly = sectionType === ESettingsSectionType.READONLY;
        const isLike = !!(meta && meta.likes && meta.likes.length);

        const props = getCache({
            ...comment,
            cardId,
            boardId,
            isChatView,
            isMyComment: author.hash === hash,
            isActive: !getCardIsLoading(state, cardId) && getEditCommentId(state) === comment.id,
            isLike,
            isSameUserPrevComment,
            isSameUserNextComment,
            isNewDivider,
            isReadonly,
            isUserTimeFormat12: getUserTimeFormat12(state),
            driveDocs: commentDriveDocs.sort((attach1, attach2) => attach1.orderNumber - attach2.orderNumber),
            replyAttachment: replyAttachmentId && getDriveDoc(state, replyAttachmentId),
            replyComment: replyCommentId && getCommentById(state, cardId, replyCommentId), // todo 4449 грузить  реплай коммент отдельно
            replyText: replyCommentId && getCommentReplyText(state, cardId, comment.id),
        });
        // analyze.finish();
        return props;
    };
}

const mapDispatchToProps = (
    dispatch: any,
    { comment, scrollToComment, onEdit: onOwnEdit, boardId }: ICommentHOCProps
): ICardCommentEvents => {
    const { cardId, id } = comment;
    return {
        onAttachmentClick: (attachmentId) => dispatch(onAttachmentClick(attachmentId)),
        onAttachmentReply: (attachmentId) => dispatch(onAttachmentReply(id, attachmentId)),
        onGetLink: () => dispatch(onGetLink(cardId, id)),
        onLike: () => dispatch(onLike(boardId, cardId, id)),
        onRemove: () => dispatch(onRemove(cardId, id)),
        onReply: (text) => dispatch(onReply(cardId, id, text)),
        onEdit: () => dispatch(onEdit(id, onOwnEdit)),
        scrollToComment,
    };
};

export const CommentHOC = connect(
    mapStateToProps,
    mapDispatchToProps
)(Comment);

CommentHOC.displayName = 'CommentHOC';
